import axiosInstance from "../../apiAxios/axiosInstance";

export const WhereHouseList = async (payload) => {
  const response = await axiosInstance.post("/admin/warehouses-list", payload);
  return response.data;
};
export const ActiveWhereHouseList = async (payload) => {
  const response = await axiosInstance.post("/admin/active-warehouses-list", payload);
  return response.data;
};
export const ActiveSupplierList = async(payload) => {
   const resposne=await axiosInstance.post("/admin/active-supplier-list",payload);
   return resposne.data
};
export const AddWhereHouse= async (payload) => {
  const response = await axiosInstance.post("/admin/warehouses-store", payload);
  return response.data;
};

export const ViewWhereHouse = async (payload) => {
  const response = await axiosInstance.post("/admin/warehouses-show", payload);
  return response.data;
};

export const UpdateWhereHouse = async (payload) => {
  const response = await axiosInstance.post("/admin/warehouses-update", payload);
  return response.data;
};

export const DeleteWhereHouse = async (payload) => {
  const response = await axiosInstance.post("/admin/warehouses-delete", payload);
  return response.data;
};

export const WhereHouseChangeStatus = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/warehouses-status-update",
    payload
  );
  return response.data;
};